<template>
  <v-dialog v-model="dialog" width="500">
    <template v-slot:activator="{ on }">
      <v-btn text icon color="#808f9c">
        <v-icon v-on="on" size="18" class="my-vicon">settings</v-icon>
      </v-btn>
    </template>

    <v-card :loading="loading">
      <div class="pa-4">
        <!--
        <v-select
          v-model="selected"
          :items="Minicharts"
          itemText="name"
          label="Select chart..."
          color="#4dbac0"
          autocomplete="off"
          return-object
        ></v-select>
        -->
      </div>
      
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="primary" text @click="dialog = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import { mapGetters } from "vuex";
export default {
  props: ["minis", "position"],
  data() {
    return {
      selected: null,
      dialog: false,
      mounted: false,
      loading: false,
    };
  },
  computed: {
    ...mapGetters(["Minicharts", "TagDetailMinicharts", "StrategyDetailMinicharts"])
  },
  mounted() {
    if(this.minis == "minichartsTag") this.selected = this.TagDetailMinicharts[this.position];
    else if(this.minis == "minichartsStrategy") this.selected = this.StrategyDetailMinicharts[this.position];
  },
  watch: {
    selected: function(val) {
      if (this.mounted && val != "") {
        this.update();
      }
      this.mounted = true;
    }
  },
  methods: {
    update() {
      var newValue = this.TagDetailMinicharts
      newValue[this.position] = this.selected
      var apiData = {
        key: this.minis,
        newValue: newValue
      };
      if(this.selected != null)
      this.API(apiData);
    },

    API(apiData) {
      this.loading = true;
      this.$store
        .dispatch("API_UPDATE_SETTINGS", apiData)
        .then(() => {
          this.loading = false;
          this.dialog = false;
        })
        .catch(() => {
          alert("API failed");
          this.loading = false;
          this.dialog = false;
        });
    }

  }
};
</script>

<style scoped>
.my-vicon {
  color: #808f9c;
  font-size: 18px;
}
.my-vicon:hover {
  color: #ffffff;
}
</style>
